// extracted by mini-css-extract-plugin
module.exports = {"icon":"chotot-icons_icon__Ggqlf","shop_verified_icon":"chotot-icons_shop_verified_icon__bEKl5"};